import { UnitSystems } from './unitSystem';

export type FavouriteWells = {
  wellIds: string[];
  tuwis: string[];
};

export enum Profiles {
  NO_ACCESS = 'NO_ACCESS',
  DRILLX = 'DRILLX',
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  PO = 'PO',
  REPORTING_PARTNER = 'REPORTING_PARTNER',
  REPORTING_PARTNER_WITH_COSTS = 'REPORTING_PARTNER_WITH_COSTS',
}

export type UserDTO = {
  igg: string;
  firstName?: string | null;
  lastName?: string | null;
  profile: Profiles;
  unitSystem: UnitSystems;
  wellIds: string[];
  tuwis: string[];
  wellGroups: string[];
  favouriteWells: FavouriteWells;
  subscribedTuwis: string[];
  email?: string | null;
  isBeta?: boolean;
  tightWellAccessible?: boolean;
};

export type UserWithNoCriticalInfoDTO = {
  igg: string;
  firstName: string | null;
  lastName: string | null;
};
